@for (vulnerabilityId of vulnerabilityIds(); track $index) {
  <div class="finding-vuln-row-container">
    <p class="finding-vuln-row">
      @if (vulnerabilityId.source !== 'UNKNOWN') {
        <span class="vuln-source-tag">{{ vulnerabilityId.source }}</span>
      }

      @if (vulnerabilityId.url) {
        <a
          class="external-link"
          [href]="vulnerabilityId.url"
          target="_blank"
          rel="noopener noreferrer"
          [attr.aria-label]="vulnerabilityId.name + ' opens in a new tab'"
        >
          {{ vulnerabilityId.name }}
        </a>
      } @else {
        <span>{{ vulnerabilityId.name }}</span>
      }
    </p>
  </div>
}
